export var Flows;
(function (Flows) {
    Flows["SETTLEMENT"] = "settlement";
    Flows["PLAN"] = "plan";
})(Flows || (Flows = {}));
export var RouteSections;
(function (RouteSections) {
    RouteSections["PAYMENT"] = "payment";
    RouteSections["SETTLEMENT"] = "settlement";
    RouteSections["PLAN"] = "plan";
})(RouteSections || (RouteSections = {}));
export var Routes;
(function (Routes) {
    Routes["PAYMENT_OPTIONS"] = "payment.options";
    Routes["SETTLEMENT_ERROR"] = "settlement.error";
    Routes["SETTLEMENT_OPTIONS"] = "settlement.options";
    Routes["SETTLEMENT_QUESTIONNAIRE"] = "settlement.questionnaire";
    Routes["SETTLEMENT_START"] = "settlement.start";
    Routes["SETTLEMENT_REVIEW"] = "settlement.review";
    Routes["SETTLEMENT_SUCCESS"] = "settlement.success";
    Routes["SETTLEMENT_CONTACT"] = "settlement.contact";
    Routes["PLAN_CONFIRM"] = "plan.confirm";
    Routes["PLAN_START"] = "plan.start";
    Routes["PLAN_QUESTIONNAIRE"] = "plan.questionnaire";
    Routes["PLAN_ERROR"] = "plan.error";
    Routes["PLAN_CONTACT"] = "plan.contact";
    Routes["PLAN_REVIEW"] = "plan.review";
    Routes["PLAN_SUCCESS"] = "plan.success";
    Routes["PLAN_FORBEARANCE"] = "plan.forbearance";
})(Routes || (Routes = {}));
export var BUSINESS_ERROR_CODE = {
    PAYMENT_METHOD_EXIST: 'payment-method.exists',
    PAYMENT_METHOD_ACCOUNT_INVALID: 'payment-method.account.invalid',
    PAYMENT_METHOD_ACCOUNT_LOCKED: 'payment-method.account.locked',
    PAYMENT_METHOD_TYPE_INVALID: 'payment-method.type.invalid',
    PAYMENT_METHOD_INVALID: 'payment-method.invalid',
    PAYMENT_METHOD_ACCOUNT_FAILED: 'payment-method.account.locked.letter.send-failed'
};
export var knownBusinessErrors = ['600018', '600023'];
export var CAPAutopayStatuses;
(function (CAPAutopayStatuses) {
    CAPAutopayStatuses["ERROR"] = "error";
    CAPAutopayStatuses["WARNING"] = "warning";
    CAPAutopayStatuses["INFO"] = "info";
})(CAPAutopayStatuses || (CAPAutopayStatuses = {}));
//# sourceMappingURL=index.js.map